
export function _debounce (fn, time) {
  time = time || 200
  let timer = null
  return function (...args) {
    const _this = this
    if (timer) {
      clearTimeout(timer)
    }
    timer = setTimeout(function () {
      timer = null
      fn.apply(_this, args)
    }, time)
  }
}

export function _throttle (fn, time) {
  let timer = null
  time = time || 1000
  return function (...args) {
    if (timer) {
      return
    }
    const _this = this
    timer = setTimeout(() => {
      timer = null
    }, time)
    fn.apply(_this, args)
  }
}

export function trimHtml (htmlStr) {
  return htmlStr.replace(/<\/?.+?\/?>|\r|\n|\s*/g, '')
}

export const bcadd = (data1, data2) => {
  let r1, r2, m
  try { r1 = data1.toString().split('.')[1].length } catch (e) { r1 = 0 }
  try { r2 = data2.toString().split('.')[1].length } catch (e) { r2 = 0 }
  m = Math.pow(10, Math.max(r1, r2))
  return (data1 * m + data2 * m) / m
}

export const bcsub = (data1, data2) => {
  let r1, r2, m, n
  try { r1 = data1.toString().split('.')[1].length } catch (e) { r1 = 0 }
  try { r2 = data2.toString().split('.')[1].length } catch (e) { r2 = 0 }
  m = Math.pow(10, Math.max(r1, r2))
  n = (r1 >= r2) ? r1 : r2
  return ((data1 * m - data2 * m) / m).toFixed(n)
}

export const bcmul = (data1, data2) => {
  let m = 0
  let s1 = data1.toString()
  let s2 = data2.toString()
  try { m += s1.split('.')[1].length } catch (e) {}
  try { m += s2.split('.')[1].length } catch (e) {}
  return Number(s1.replace('.', '')) * Number(s2.replace('.', '')) / Math.pow(10, m)
}

export const bcdiv = (data1, data2) => {
  let r1, r2
  let t1 = 0
  let t2 = 0
  try { t1 = data1.toString().split('.')[1].length } catch (e) {}
  try { t2 = data2.toString().split('.')[1].length } catch (e) {}
  r1 = Number(data1.toString().replace('.', ''))
  r2 = Number(data2.toString().replace('.', ''))
  return (r1 / r2) * Math.pow(10, t2 - t1)
}

export const removeHtmlStyle = (html) => {
  html = html + ''
  html = html.replace(/[ t]*style[ t]*=[ t]*("[^"]+")|('[^']+')/ig, '')
  html = html.replace(/[ t]*width[ t]*=[ t]*("[^"]+")|('[^']+')/ig, '')
  html = html.replace(/[ t]*height[ t]*=[ t]*("[^"]+")|('[^']+')/ig, '')
  html = html.replace(/[ t]*width[ t]*=[ t]*[^ t]+/ig, '')
  html = html.replace(/[ t]*height[ t]*=[ t]*[^ t]+/ig, '')
  return html
}

export const delayRun = (cb, timeOut) => {
  const delayFn = new Promise(resolve => {
    setTimeout(resolve, timeOut * 1000)
  })
  return new Promise(resolve => {
    Promise.all([delayFn, cb]).then(res => {
      resolve(res[1])
    })
  })
}



// WEBPACK FOOTER //
// ./src/util/util.js